const sicilySlugs = {
  en: 'sicily',
  it: 'sicilia',
  de: 'sizilien',
  fr: 'sicile',
};
const pugliaSlugs = {
  en: 'puglia',
  it: 'puglia',
  de: 'apulien',
  fr: 'pouilles',
};

export const getRegionByLocale = (
  region: 'sicily' | 'puglia' | undefined,
  locale: Locale,
) => {
  if (region === 'sicily') {
    return sicilySlugs[locale];
  } else if (region === 'puglia') {
    return pugliaSlugs[locale];
  }

  return 'sicily';
};
